Application.Forms = {
    ready: function () {

        this.Validators.ready();
        this.CheckBoxShow.ready();


        //https://forum.nette.org/cs/25380-ignorovani-onclick-handleru-po-odeslani-formulare

        jQuery.fn.preventDoubleSubmission = function() {
            $(this).on('submit',function(e){
                var $form = $(this);

                if (Nette.validateForm(this)) {
                    if ($form.data('submitted') === true) {
                        e.preventDefault();
                    } else {
                        $form.data('submitted', true);
                        $form.find("[type='submit']").addClass("disabled"); // .attr('disabled','disabled');
                        // Po nepridavani atributu disabled opet funguje..
                    }
                }
            });

            return this;
        };

        $('#submissionForm').preventDoubleSubmission();
        $('#loginForm').preventDoubleSubmission();

    }
}